import { render } from "./Waybill.vue?vue&type=template&id=2cdedd26&scoped=true&ts=true"
import script from "./Waybill.vue?vue&type=script&lang=ts"
export * from "./Waybill.vue?vue&type=script&lang=ts"

import "./Waybill.vue?vue&type=style&index=0&id=2cdedd26&scoped=true&lang=css"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdedd26"]])

export default __exports__